document.addEventListener("DOMContentLoaded", function () {

    console.log("Unified shortcode system running");

    // =========================
    // SHORTCODE PARSER
    // =========================
    function parseShortcodes() {

        const container = document.querySelector('.rte, .article-template__content');

        if (!container) return;

        let html = container.innerHTML;

        // product card
        html = html.replace(
            /\[shop-card\s+([^\]]+)\]/g,
            (match, attrs) => {

                const handle = (attrs.match(/handle="([^"]+)"/) || [])[1] || "";
                const benefits = (attrs.match(/benefits="([^"]*)"/) || [])[1] || "";

                const category = (attrs.match(/category="([^"]*)"/) || [])[1] || "";
                const categoryColor = (attrs.match(/category_color="([^"]*)"/) || [])[1] || "gold";

                const badge = (attrs.match(/badge="([^"]*)"/) || [])[1] || "";
                const badgeColor = (attrs.match(/badge_color="([^"]*)"/) || [])[1] || "gold";

                return `
      <div class="bw-product-card"
           data-product-card
           data-handle="${handle}"
           data-benefits="${benefits}"
           data-category="${category}"
           data-category-color="${categoryColor}"
           data-badge="${badge}"
           data-badge-color="${badgeColor}">
      </div>
    `;
            }
        );




        // quick-picks
        html = html.replace(
            /\[quick-picks\s+items="([\s\S]*?)"\]/g,
            function (match, items) {

                return `<div class="bw-quick-picks" data-items="${items.trim()}"></div>`;
            }
        );
        // comparison-table
        html = html.replace(
            /\[comparison-table\s+items="([^"]+)"\]/g,
            `<div class="bw-comparison-table" data-items="$1"></div>`
        );

        // pros-cons
        html = html.replace(
            /\[pros-cons\s+pros="([^"]*)"\s+cons="([^"]*)"\]/g,
            function (match, pros, cons) {

                const prosList = pros.split('|').map(item => `<li>${item}</li>`).join('');
                const consList = cons.split('|').map(item => `<li>${item}</li>`).join('');

                return `
        <div class="bw-pros-cons">
          <div class="bw-pros">
            <h4>Pros</h4>
            <ul>${prosList}</ul>
          </div>
          <div class="bw-cons">
            <h4>Cons</h4>
            <ul>${consList}</ul>
          </div>
        </div>
      `;
            }
        );


        // TOC
        html = html.replace(
            /\[toc\]/g,
            `<div id="bw-toc"></div>`
        );

        // NOTE BOX
        html = html.replace(
            /\[note-box\s+([^\]]+)\]([\s\S]*?)\[\/note-box\]/g,
            (match, attrs, content) => {

                const type = (attrs.match(/type="([^"]+)"/) || [])[1] || "info";
                const title = (attrs.match(/title="([^"]+)"/) || [])[1];

                return `
          <div class="bw-note-box bw-note-${type}">
            ${title ? `<div class="bw-note-title">${title}</div>` : ""}
            <div class="bw-note-content">
              ${content.trim()}
            </div>
          </div>
        `;
            }
        );

        // verdict box
        html = html.replace(
            /\[verdict\s+text="([^"]+)"\]/g,
            (match, text) => {

                return `
      <div class="bw-verdict-box">
        <p>${text}</p>
      </div>
    `;
            }
        );

        // reading-time + last updated
        html = html.replace(
            /\[reading-time\s+([^\]]+)\]/g,
            (match, attrs) => {

                const updated = (attrs.match(/updated="([^"]+)"/) || [])[1] || '';

                return `
      <div class="bw-reading-time" data-updated="${updated}">
        <span class="bw-rt-time">Loading...</span>
        <span class="bw-rt-divider">•</span>
        <span class="bw-rt-updated">Last updated: ${updated}</span>
      </div>
    `;
            }
        );

        // category-badge
        html = html.replace(
            /\[category-badge\s+([^\]]+)\]/g,
            (match, attrs) => {

                const text = (attrs.match(/text="([^"]+)"/) || [])[1] || '';
                const color = (attrs.match(/color="([^"]+)"/) || [])[1] || 'gold';

                return `
      <span class="bw-category-badge bw-category-badge--${color}">
        ${text}
      </span>
    `;
            }
        );

        // winner-badge
        html = html.replace(
            /\[winner-badge\s+([^\]]+)\]/g,
            (match, attrs) => {

                const text = (attrs.match(/text="([^"]+)"/) || [])[1] || "Our Pick";
                const color = (attrs.match(/color="([^"]+)"/) || [])[1] || "gold";

                return `
      <div class="bw-winner-badge bw-badge-${color}">
        ${text}
      </div>
    `;
            }
        );
        // CTA BANNER
    //     html = html.replace(
    //         /\[cta-banner\s+text="([^"]+)"\s+button="([^"]+)"\s+link="([^"]+)"\]/g,
    //         function (match, text, button, link) {

    //             return `
    //   <div class="bw-cta-banner">
    //     <div class="bw-cta-inner">
          
    //       <div class="bw-cta-text">
    //         ${text}
    //       </div>

    //       <a href="${link}" class="bw-cta-button">
    //         ${button}
    //       </a>

    //     </div>
    //   </div>
    // `;
    //         }
    //     );
    // CTA BANNER (ADVANCED)
// CTA BANNER (FINAL CLEAN VERSION)
html = html.replace(
  /\[cta-banner([^\]]+)\]/g,
  function (match, attrs) {

    function getAttr(name) {
      const regex = new RegExp(name + '="([^"]+)"');
      const result = attrs.match(regex);
      return result ? result[1] : '';
    }

    const text = getAttr('text');
    const button = getAttr('button');
    const link = getAttr('link');
    const subtext = getAttr('subtext');

    const bgColor = getAttr('bg-color');
    const bgImage = getAttr('bg-image');

    const textColor = getAttr('text-color');
    const accent = getAttr('btnaccent');
    const image = getAttr('image');
    const btntxtcolor=getAttr('btntxt-color');

    

    // BACKGROUND LOGIC (image > color)
    let backgroundStyle = '';

    if (bgImage) {
      backgroundStyle = `
        background-image:url(${bgImage});
        background-size:cover;
        background-position:center;
      `;
    } else if (bgColor) {
      backgroundStyle = `background:${bgColor};`;
    }

    const style = `
      ${backgroundStyle}
      ${textColor ? `color:${textColor};` : ''}
    `;

    return `
      <div class="bw-cta-banner" style="${style}">
        <div class="bw-cta-inner">

          <div class="bw-cta-content">
            <div><div class="bw-cta-text" style="color:${textColor};">${text}</div>

            ${subtext ? `<p class="ai-routine-banner__subheading" style="color:${textColor};">${subtext}</p>` : ''}
</div>
            <a href="${link}" 
               class="bw-cta-button"
               style="${accent ? `background:${accent}; border-color:${accent}; color:${btntxtcolor};` : ''}">
              ${button}
            </a>
          </div>

        </div>
      </div>
    `;
  }
);

        container.innerHTML = html;
    }

  function initProductCards() {

        const elements = document.querySelectorAll("[data-product-card]");


        elements.forEach(card => {

            const handle = card.dataset.handle;
            const benefits = (card.dataset.benefits || "").split("|");

            const category = card.dataset.category;
            const categoryColor = card.dataset.categoryColor || "gold";

            const badge = card.dataset.badge;
            const badgeColor = card.dataset.badgeColor || "gold";
            
            const showATC = card.dataset.addToCart === "yes";
            const showView = card.dataset.viewProduct !== "no"; // default = show

            const addtocarttext=card.dataset.addtocarttext;
            const viewproduttext=card.dataset.viewproduttext;

            if (!handle) return;

            // Skeleton
            card.innerHTML = `
                  <div class="bw-pc-inner loading">
                    <div class="bw-pc-image"></div>
                    <div class="bw-pc-content">
                      <h3 class="bw-pc-title"></h3>
                      <div class="bw-pc-price"></div>
                      <ul class="bw-pc-benefits"></ul>
                    </div>
                  </div>
                `;

            fetch(`/products/${handle}.js`)
                .then(res => res.json())
                .then(product => {

                    if (!product) return;

                    const price = new Intl.NumberFormat('nl-NL', {
                        style: 'currency',
                        currency: 'EUR'
                    }).format(product.price / 100);

                    const isDutch = window.location.pathname.includes('/nl');
                    const productUrl = isDutch ? `/nl/products/${product.handle}` : `/products/${product.handle}`;

                    let image = product.images?.[0] || product.featured_image || "";

                      if (image && image.startsWith('//')) {
                      image = 'https:' + image;
                    }
                    const url = `${productUrl}`;
                    let variant = null;

                      if (product.variants?.length) {

                          // 1. Try available + purchasable
                          variant = product.variants.find(v => 
                              v.available && v.inventory_policy !== 'deny'
                          );

                          // 2. fallback to ANY available
                          if (!variant) {
                              variant = product.variants.find(v => v.available);
                          }

                          // 3. fallback to first (last resort)
                          if (!variant) {
                              variant = product.variants[0];
                          }
                      }

                      const variantId = variant?.id || null;

                    const benefitsHTML = benefits
                        .filter(b => b.trim() !== "")
                        .map(b => `<li>${b}</li>`)
                        .join("");

                    const badgeHTML = badge
                        ? `<div class="bw-winner-badge bw-badge-${badgeColor}">${badge}</div>`
                        : "";

                    const categoryHTML = category
                        ? `<div class="bw-category-badge bw-category-${categoryColor}">${category}</div>`
                        : "";

                    card.innerHTML = `
                      ${badgeHTML}
                      ${categoryHTML}

                      <div class="bw-pc-inner">
                        
                        <div class="bw-pc-image">
                          <img src="${image}" alt="${product.title}">
                        </div>

                        <div class="bw-pc-content">
                          <h3 class="bw-pc-title">
                            <a href="${url}">${product.title}</a>
                          </h3>

                          <div class="bw-pc-price">${price}</div>

                          <ul class="bw-pc-benefits">
                            ${benefitsHTML}
                          </ul>

                          <div class="bw-pc-actions">

                          ${showView ? `
                            <a href="${url}" class="bw-pc-btn">${viewproduttext}</a>
                          ` : ""}

                          ${(showATC && variantId) ? `
                            <button class="bw-atc" data-variant="${variantId}">
                              ${addtocarttext}
                            </button>
                          ` : ""}

                        </div>
                        </div>

                      </div>
                    `;

                })
                .catch(err => {
                    console.error("Product fetch error:", err);
                });

        });
    }


    // =========================
    // QUICK PICKS
    // =========================
    function initQuickPicks() {
// const headerLabel = attrs.header || "Category"; // fallback
        document.querySelectorAll(".bw-quick-picks").forEach(function (el) {

const headerLabel = el.dataset.header || "Category"; // ✅ FIXED

            let raw = el.getAttribute("data-items");
            if (!raw) return;

            let rows = raw.split(/\n|,/).map(r => r.trim()).filter(r => r);

            let table = `
        <table class="bw-qp-table">
          <thead>
            <tr>
              <th>${headerLabel}</th>
              <th>Product</th>
            </tr>
          </thead>
          <tbody>
      `;

            let promises = rows.map(row => {

                let parts = row.split("|");

                let category = parts[0]?.trim();
                let handle = parts[1]?.trim();

                if (!handle) return "";

                return fetch(`/products/${handle}.js`)
                    .then(res => res.json())
                    .then(product => {

                      const isDutch = window.location.pathname.includes('/nl');
                    const productUrl = isDutch ? `/nl/products/${product.handle}` : `/products/${product.handle}`;

                        return `
              <tr>
                <td class="bw-qp-category">${category}</td>
                <td class="bw-qp-product">
                  <a href="${productUrl}">
                    ${product.title}
                  </a>
                </td>
              </tr>
            `;
                    })
                    .catch(() => "");
            });

            Promise.all(promises).then(results => {

                table += results.join("");
                table += "</tbody></table>";

                el.innerHTML = table;
            });

        });
    }

    // =========================
    // COMPARISON TABLE
    // =========================
    function initComparisonTables() {

        const tables = document.querySelectorAll('.bw-comparison-table');

        tables.forEach(table => {

            const items = table.dataset.items;
            if (!items) return;

            const handles = items.split('|');

            let html = `
               <table class="bw-table">
            <thead>
              <tr>
                <th>Product</th>
                <th>Prijs</th>
                <th>Kwaliteitskenmerk</th>
                <th>Beste voor</th>
              </tr>
            </thead>
            <tbody>
            `;

            // 🔥 Fetch products (basic data only)
            const fetches = handles.map(handle =>
                fetch(`/products/${handle}.js`)
                    .then(res => res.json())
                    .catch(() => null)
            );

            Promise.all(fetches).then(products => {

                products.forEach(product => {

                    if (!product) return;

                    // 🔥 Get metafields from injected Liquid object
                    const meta = window.productMetafields?.[product.handle] || {};

                    let keyFeatures = meta.key_features || [];
                    let bestFor = meta.best_for || [];

                    console.log({
  handle: product.handle,
  id: product.id,
  meta: window.productMetafields?.[product.handle]
});

                    // 🔥 Format array → list
                    // function formatList(items) {
                    //     if (!items || !items.length) return "—";

                    //     return `<ul>` + items
                    //         .filter(i => i && i.trim())
                    //         .map(i => `<li>${i}</li>`)
                    //         .join("") + `</ul>`;
                    // }
              function formatList(items) {
  if (!items) return "—";

  // If array → render as UL
  if (Array.isArray(items)) {
    return `<ul>` + items
      .filter(i => i && i.trim())
      .map(i => `<li>${i}</li>`)
      .join("") + `</ul>`;
  }

  // If string → strip HTML
  if (typeof items === "string") {
    return items.replace(/<[^>]*>/g, '');
  }

  return "—";
}

                    const isDutch = window.location.pathname.includes('/nl');
                    const productUrl = isDutch ? `/nl/products/${product.handle}` : `/products/${product.handle}`;

                    html += `
                    <tr class="bw-table-row">
                      <td>
                        <a href="${productUrl}">
                          ${product.title}
                        </a>
                      </td>
                      <td>€${(product.price / 100).toFixed(2)}</td>
                      <td>${formatList(keyFeatures)}</td>
                      <td>${formatList(bestFor)}</td>
                    </tr>
                  `;

                });
                html += `
                </tbody>
            </table>
        </div>
        `;

                table.innerHTML = html;

            });

        });

    }



    // 🔥 Run on load
    document.addEventListener("DOMContentLoaded", initComparisonTables);

    // =========================
    // ADD TO CART
    // =========================
    document.addEventListener('click', function (e) {
        if (e.target.classList.contains('bw-atc')) {

            const variantId = e.target.dataset.variant;

            fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ id: variantId, quantity: 1 })
            })
                .then(() => {
                    e.target.innerText = "Added!";
                });
        }
    });

    // =========================
    // FAQ
    // =========================
    function parseFAQShortcode() {

        document.querySelectorAll("p").forEach(p => {

            if (p.innerHTML.includes("[faq]")) {

                let html = p.innerHTML;

                html = html
                    .replace("[faq]", '<div class="bw-faq" data-single="true">')
                    .replace("[/faq]", '</div>');

                html = html.replace(/\[faq-item question="(.*?)"\]/g,
                    '<div class="bw-faq-item"><h3 class="bw-faq-question">$1</h3><div class="bw-faq-answer">'
                );

                html = html.replace(/\[\/faq-item\]/g, '</div></div>');

                p.innerHTML = html;
            }

        });
    }

  function initFAQ() {

    const faqBlocks = document.querySelectorAll(".bw-faq");

    faqBlocks.forEach(faq => {

        const items = faq.querySelectorAll(".bw-faq-item");

        items.forEach(item => {

            const question = item.querySelector(".bw-faq-question");
            const answer = item.querySelector(".bw-faq-answer");

            if (!question || !answer) return;

            question.addEventListener("click", () => {

                items.forEach(i => {
                    if (i !== item) {
                        i.classList.remove("active");
                        const a = i.querySelector(".bw-faq-answer");
                        if (a) a.style.maxHeight = null;
                    }
                });

                item.classList.toggle("active");

                answer.style.maxHeight = item.classList.contains("active")
                    ? answer.scrollHeight + "px"
                    : null;
            });

        });

        // open first
        const firstItem = items[0];
        if (firstItem) {
            const firstAnswer = firstItem.querySelector(".bw-faq-answer");
            firstItem.classList.add("active");
            if (firstAnswer) {
                firstAnswer.style.maxHeight = firstAnswer.scrollHeight + "px";
            }
        }

        // ✅ SCHEMA
        const schema = {
            "@context": "https://schema.org",
            "@type": "FAQPage",
            "mainEntity": []
        };

        items.forEach(item => {
            const q = item.querySelector(".bw-faq-question")?.innerText;
            const a = item.querySelector(".bw-faq-answer")?.innerText;

            if (!q || !a) return;

            schema.mainEntity.push({
                "@type": "Question",
                "name": q,
                "acceptedAnswer": {
                    "@type": "Answer",
                    "text": a
                }
            });
        });

        if (schema.mainEntity.length > 0) {
            const script = document.createElement("script");
            script.type = "application/ld+json";
            script.textContent = JSON.stringify(schema);
            document.head.appendChild(script);
        }

    });

}
// pros cons
function initProsCons() {

    document.querySelectorAll('.bw-pros-cons').forEach(el => {

        const pros = (el.dataset.pros || "").split('|');
        const cons = (el.dataset.cons || "").split('|');

        const prosList = pros
            .filter(p => p.trim() !== "")
            .map(p => `<li>${p}</li>`)
            .join('');

        const consList = cons
            .filter(c => c.trim() !== "")
            .map(c => `<li>${c}</li>`)
            .join('');

        el.innerHTML = `
            <div class="bw-pros">
                <h4>Voordelen</h4>
                <ul>${prosList}</ul>
            </div>
            <div class="bw-cons">
                <h4>Nadelen</h4>
                <ul>${consList}</ul>
            </div>
        `;

    });

}

    // =========================
    // TOC GENERATOR
    // =========================
    // TOC GENERATOR
    // =========================
    function initTOC() {

      const tocContainer = document.querySelector('.bw-toc-container');

if (!tocContainer) return;

        const container = document.querySelector('.rte, .article-template__content');
        if (!container) return;

        const headings = container.querySelectorAll('h2');
        if (!headings.length) return;

        const list = document.createElement('ul');
        list.className = 'bw-toc-list';

        headings.forEach((heading, index) => {

            const id = "bw-section-" + index;
            heading.id = id;

            const li = document.createElement('li');
            li.innerHTML = `<a href="#${id}">${heading.innerText}</a>`;
            list.appendChild(li);

        });
let toc = tocContainer.querySelector('.bw-toc-inner');

if (!toc) {

    toc = document.createElement('div');
    toc.className = 'bw-toc-inner';

    toc.innerHTML = `
        <div class="bw-toc-title">Table Of Contents</div>
    `;

    tocContainer.prepend(toc);
}

        toc.appendChild(list);

        const links = toc.querySelectorAll('a');
        const tocTitle = toc.querySelector('.bw-toc-title');

        // 👉 helper to update active section wrapper
        function setActiveSection(currentId) {

            // remove from all
            container.querySelectorAll('.active-section').forEach(el => {
                el.classList.remove('active-section');
            });

            const activeHeading = document.getElementById(currentId);
            if (!activeHeading) return;

            // 🔥 change this selector based on your layout
            const wrapper = activeHeading.closest('div');

            if (wrapper) {
                wrapper.classList.add('active-section');
            }

        }

        // ✅ CLICK
        links.forEach(link => {
            link.addEventListener('click', function () {

                links.forEach(l => l.classList.remove('active'));
                this.classList.add('active');

                tocTitle.classList.add('active');

                const id = this.getAttribute('href').replace('#', '');
                setActiveSection(id);

            });
        });

        // ✅ SCROLL
       window.addEventListener('scroll', () => {

    let closest = null;
    let closestOffset = Infinity;

    headings.forEach((heading) => {

        const rect = heading.getBoundingClientRect();
        const offset = Math.abs(rect.top - 120); // adjust this value

        if (rect.top <= 150 && offset < closestOffset) {
            closest = heading;
            closestOffset = offset;
        }

    });

    if (!closest) return;

    const currentId = closest.id;

    links.forEach(link => {
        link.classList.remove('active');

        if (link.getAttribute('href') === "#" + currentId) {
            link.classList.add('active');
        }
    });

    tocTitle.classList.add('active');
    setActiveSection(currentId);

});

    }
    // =========================

    function initReadingTime() {

        const content = document.querySelector('.rte, .article-template__content');
        const blocks = document.querySelectorAll('.bw-reading-time');

        if (!content || !blocks.length) return;

        // get text content
        const text = content.innerText || '';
        const words = text.trim().split(/\s+/).length;

        // average reading speed = 200 wpm
        const minutes = Math.ceil(words / 200);

        blocks.forEach(block => {
            const timeEl = block.querySelector('.bw-rt-time');
            if (timeEl) {
                timeEl.textContent = `${minutes} min read`;
            }
        });
    }


    


    // =========================
    // RUN EVERYTHING
    // =========================
    parseShortcodes();
    parseFAQShortcode();
    initProductCards();
    initQuickPicks();
    initComparisonTables();
    initFAQ();
    initReadingTime();
    initTOC();
initProsCons();
 

});



 